import { Injectable } from '@angular/core';

@Injectable()
export class TransformComponentsService {
  removeCutouts(
    cutouts: any[],
    onSuccess: (data: { drawing: string; qd: string }) => void,
    onErrors: (errors: string[]) => void
  ): void {
    throw new Error(
      'Cannot call removeCutouts() - TransformComponentsService not provided!'
    );
  }

  removeComponents(
    components: any[],
    onSuccess: (data: { drawing: string; qd: string }) => void,
    onErrors: (errors: string[]) => void,
    onWarnings: (warnings: string[]) => void
  ): void {
    throw new Error(
      'Cannot call removeComponents() - TransformComponentsService not provided!'
    );
  }

  moveCutouts(cutouts: any[], move: any): void {
    throw new Error(
      'Cannot call moveCutouts() - TransformComponentsService not provided!'
    );
  }

  moveComponents(
    components: any[],
    moveAmounts: any,
    onSuccess: (data: { drawing: string; qd: string }) => void,
    onErrors: (errors: string[]) => void,
    onWarnings: (warnings: string[]) => void
  ): void {
    throw new Error(
      'Cannot call moveComponents() - TransformComponentsService not provided!'
    );
  }
}
